export default [
    {
        path: '/policy',
        name: 'policy',
        component: () => import('VIEWS/Policy.vue')
    }
]